var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topback',{attrs:{"title":"KYC Partner","path":"back"}}),_vm._v(" "),_c('div',{staticClass:"mt-6"},[_c('kycpartnerlist')],1),_vm._v(" "),_c('md-button',{staticClass:"fixed-buttom",attrs:{"type":"primary","round":""},on:{"click":_vm.go_addkyc}},[_vm._v("Add Kyc Partner")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d84f84c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/my/kycpartner.vue
// module id = null
// module chunks = 